import axios from 'axios';

const baseURL = 'https://www.upmake.cn/api';
const instance = axios.create({
	baseURL,
	timeout: 30000,
});

// 请求拦截器
instance.interceptors.request.use(
	config => {
		// 在发送请求之前做些什么
		return config;
	},
	error => {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

// 响应拦截器
instance.interceptors.response.use(
	response => {
		// 对响应数据做点什么
		return response.data;
	},
	error => {
		// 对响应错误做点什么
		return Promise.reject(error);
	}
);

// 封装GET请求
export const ajaxGet = (url, params) => {
	return instance.get(url, {
		params
	});
};

// 封装POST请求
export const ajaxPost = (url, data) => {
	return instance.post(url, data);
};

export default instance;